import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";
import { ArrowRight, Sparkles, Star } from "lucide-react";

export default function Hero() {
  const { t } = useLanguage();

  return (
    <section
      className="relative overflow-hidden bg-brand-bg pt-12 lg:pt-24 pb-24 grain"
      data-testid="hero-section"
    >
      <div className="container-pad relative">
        <div className="grid lg:grid-cols-[1.15fr_1fr] gap-14 lg:gap-20 items-center">
          <div className="animate-fade-up">
            <div className="overline inline-flex items-center gap-2">
              <Sparkles size={14} />
              {t.hero.overline}
            </div>
            <h1 className="mt-5 font-serif text-5xl sm:text-6xl lg:text-7xl leading-[0.95] text-brand-primary tracking-tight">
              {t.hero.title}{" "}
              <span className="italic text-brand-accent">{t.hero.title_accent}</span>
            </h1>
            <p className="mt-7 text-lg sm:text-xl text-brand-text/75 leading-relaxed max-w-xl">
              {t.hero.subtitle}
            </p>

            <div className="mt-10 flex flex-wrap items-center gap-4">
              <Link
                to="/contact"
                data-testid="hero-cta-primary"
                className="inline-flex items-center gap-2 rounded-full bg-brand-primary text-brand-surface px-7 py-4 text-sm font-semibold tracking-wide transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg"
              >
                {t.hero.cta_primary}
                <ArrowRight size={16} />
              </Link>
              <Link
                to="/services"
                data-testid="hero-cta-secondary"
                className="inline-flex items-center gap-2 rounded-full border border-brand-primary/30 text-brand-primary px-7 py-4 text-sm font-semibold tracking-wide hover:border-brand-primary transition-colors"
              >
                {t.hero.cta_secondary}
              </Link>
            </div>

            <div className="mt-12 flex items-center gap-4">
              <img
                src="/julio.jpg"
                alt="Julio Rodríguez"
                className="h-14 w-14 rounded-full object-cover border-2 border-brand-bg shadow-sm"
                style={{ objectPosition: "center 20%" }}
              />
              <div>
                <div className="flex items-center gap-1 text-brand-accent">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <Star key={i} size={14} fill="currentColor" stroke="none" />
                  ))}
                </div>
                <p className="text-sm text-brand-text/80 font-medium mt-0.5">
                  {t.hero.founder_byline}
                </p>
                <p className="text-xs text-brand-muteText">
                  {t.hero.stat_value} · {t.hero.stat_label}
                </p>
              </div>
            </div>
          </div>

          <div className="relative animate-fade-up" style={{ animationDelay: "150ms" }}>
            <div className="absolute -inset-6 rounded-3xl bg-brand-subtle/80 -rotate-2" aria-hidden />
            <img
              src="/julio.jpg"
              alt="Julio Rodríguez, Fundador — Rodríguez Tax Services"
              className="relative w-full h-[440px] lg:h-[560px] object-cover rounded-2xl shadow-xl"
              style={{ objectPosition: "center 18%" }}
              loading="eager"
            />
            <div
              className="absolute -bottom-6 -left-6 lg:-left-10 bg-brand-surface border border-brand-line rounded-xl p-5 shadow-lg max-w-xs"
              data-testid="hero-stat-card"
            >
              <div className="overline text-brand-accent">{t.hero.founder_label}</div>
              <div className="mt-2 font-serif text-2xl text-brand-primary leading-tight">
                Julio Rodríguez
              </div>
              <div className="text-sm text-brand-text/70 mt-1">{t.hero.founder_title}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
